import { useMemo } from "react";
import { Stack } from "@/core/components/ui/stack";
import { BusinessSettingsSidebarHeader } from "@/business-settings/common/business-settings-sidebar-header";
import { BusinessSettingsSidebarWrapper } from "@/business-settings/common/business-settings-sidebar-wrapper";
import { useBusinessSettingsSidebar } from "@/business-settings/context/business-settings-sidebar-context";
import { useBusiness } from "@/core/business";
import { sortDateDescending } from "@/core/utils/date";
import { useGetApprovalUserSpiffs } from "@/spiff-approvals";
import { FilterableSpiffList } from "@/spiffs/common/filterable-spiff-list";
import { useGetBusinessUsers } from "@/user/query";
import { splitCompoundId } from "./utils";

export const ApprovalsHistorySidebar = () => {
  const {
    state: { selectedItemId },
    resetSidebar,
  } = useBusinessSettingsSidebar();

  if (!selectedItemId) return null;

  const { spiffApprovalId, userId } = splitCompoundId(selectedItemId);
  const { businessId } = useBusiness();

  const { data: spiffs } = useGetApprovalUserSpiffs(spiffApprovalId, userId);

  const { data: businessUsers } = useGetBusinessUsers(businessId);

  // Get the user name from the business users lookup
  const name = useMemo(() => {
    if (!businessUsers) return "Unknown User";
    const user = businessUsers.find((u) => u.id === userId);
    return user ? user.display_identification || user.email : "Unknown User";
  }, [businessUsers, userId]);

  // Sort spiffs by creation date in descending order (most recent first)
  const allSpiffs = useMemo(() => {
    if (!spiffs) return [];
    return [...spiffs].sort((a, b) =>
      sortDateDescending(a.created_at, b.created_at),
    );
  }, [spiffs]);

  return (
    <BusinessSettingsSidebarWrapper>
      <BusinessSettingsSidebarHeader
        headerText="Approval spiffs"
        name={name}
        onClose={resetSidebar}
      />
      <div className="flex-1 overflow-hidden">
        <Stack gap="none" fullWidth className="h-full">
          <div className="h-full w-full pl-6 pr-2 pt-4">
            <FilterableSpiffList
              spiffs={allSpiffs}
              emptyMessage="No spiff approvals history"
            />
          </div>
        </Stack>
      </div>
    </BusinessSettingsSidebarWrapper>
  );
};
